module.exports = __webpack_public_path__ + "static/media/intro5.6b70621d.png";